import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DevicesService } from 'app/services/devices.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DataHelper } from '../../../helpers/data-helper';

@Component({
  selector: 'app-add-label-dialog',
  templateUrl: './add-label-dialog.component.html',
  styleUrls: ['./add-label-dialog.component.scss']
})
export class AddLabelDialogComponent implements OnInit {
  public addLabelForm: FormGroup;
  public productCategories = DataHelper.productCategories();
  public productCategoriesList = Object.keys(this.productCategories);

  constructor(
    public dialogRef: MatDialogRef<AddLabelDialogComponent>,
    public translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private devicesService: DevicesService
  ) {}

  ngOnInit() {
    this.addLabelForm = new FormGroup({
      productCategory: new FormControl('', [Validators.required]),
      label: new FormControl('', [Validators.required])
    });
  }

  save(): void {
    const formValue = this.addLabelForm.value;
    this.dialogRef.close(`${formValue.productCategory}==='${formValue.label}'`.trim());
  }

  close(): void {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/devices/add-label/add-label-dialog.component.ts